import { Component } from '@angular/core';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConstants } from 'src/app/app.constants';
import { DocumentsRepositoryService } from 'src/app/services/documents-repository.service';
import { DownloadFileService } from 'src/app/services/download-file.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { DocumentsDetailsRawData } from 'src/app/shared/models/documents.model';
@Component({
  selector: 'app-download-edit',
  templateUrl: './download-edit.component.html',
  styleUrls: ['./download-edit.component.scss']
})
export class DownloadEditComponent  implements ICellRendererAngularComp {
  params: ICellRendererParams;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private documentsService: DocumentsRepositoryService,
    private downloadFileService: DownloadFileService,
    private snackBarService: SnackBarService,
  ) { }

    agInit(params:ICellRendererParams): void {       
      this.params=params   
    }
    editClickHandler(rowData): void {
      this.params.context.DocumentSearchGridComponent.editDocHandler(rowData.id);
    };
  
    downloadClickHandler(rowData): void {
      const extensionType = rowData.documentName.split(".")[1];
      const formTitle =  rowData.documentName.split(".")[0];
      const downLoadInfo = {
        formName: formTitle,
        formNumber: rowData.id,
        extension: `.${extensionType}`
      };
      this.documentsService
        .getFileDownloadById(rowData.id)
        .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (solarFileDownloadData: Blob) => {
              this.downloadFileService.downloadSolarForm(
                solarFileDownloadData,
                downLoadInfo,
                false
              );
            },
            (err) => {
              this.snackBarService.showError(AppConstants.downloadDocMsgError)
            });
    };
    refresh(params: ICellRendererParams): boolean {
      this.params = params;
      return true;
    }
}
